/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-unused-vars */
import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';

import { RatingInfo } from '../../InfoPopUps';
import { getMatchTypeIndicator } from '../../../utils';
import GradientSVG from './GradientSVG';

import styles from './ratingCircle.scss';

const RatingCircle = (props) => {
    const {
        auth,
        isProProfile,
        rating,
        ratingCircleClassName,
        ratingCirclesContainerClassName,
    } = props;

    const userLoggedIn = auth && auth.user;

    let percentComplete;
    percentComplete = rating.progress ? parseFloat(rating.progress) : 0;
    const maxUTR = 16.5;
    if (rating.status === 'Rated') {
        percentComplete = (parseFloat(rating.value) * 100) / maxUTR;
    }

    return (
        <div className={`${styles.ratingCircleComp} ${ratingCircleClassName || ''} ${rating.status === 'Rated' ? styles.rated : ''}`}>
            <div
                className={`${styles.ratingCirclesContainer} ${!userLoggedIn && !isProProfile ? styles.blur : ''}  ${ratingCirclesContainerClassName || ''}`}
            >
                <GradientSVG startColor={'#00C0F7'} endColor={'#01dfcb'} idCSS={'ratingGradient'} rotation={'110'} />
                <CircularProgressbarWithChildren
                    value={percentComplete}
                    strokeWidth={2}
                    circleRatio={0.75}
                    counterClockwise={false}
                    styles={buildStyles({
                        rotation: 0.5,
                        strokeLinecap: 'butt',
                        textSize: '16px',
                        pathTransitionDuration: 0.5,
                        textColor: '#f88',
                        backgroundColor: '#3e98c7',
                    })}
                >
                    <div className={`${styles.utrContainer} ${!userLoggedIn && !isProProfile ? styles.blur : ''}`}>
                        <div className="d-flex flex-row">
                            <div
                                className={`${styles.utrValue} mr-auto ml-auto ${rating.ratingDecimal.length > 0 ? '' : styles.noDecimal} ${rating.value === 'UR' ? styles.unrated : ''} ${rating.verified ? 'verified' : ''}`}
                            >
                                {rating.ratingNumber}
                                <span className={`${styles.decimals}`}>
                                    {`${rating.ratingDecimal.length > 0 ? '.' : ''}${rating.ratingDecimal}`}
                                </span>
                            </div>
                        </div>
                        <div className={styles.utrType}>
                            {rating.utrType}
                        </div>
                        <div className={`${styles.matchTypeIndicator}`}>
                            {getMatchTypeIndicator(rating)}
                        </div>
                    </div>
                </CircularProgressbarWithChildren>
                <RatingInfo
                    rootClass={styles.ratingInfoRoot}
                    anchorClass={styles.ratingInfoAnchor}
                    rating={rating}
                    cancelText="Got it"
                    user={userLoggedIn}
                />
            </div>
            {!userLoggedIn && !isProProfile && (
                <div
                    className={`${styles.signUpToView} btn btn-primary text-uppercase`}
                    onClick={props.handleSignInCLick}
                >
                    Sign In to View Rating
                </div>
            )}
        </div>
    );
};

export default RatingCircle;
